import { useRouter } from 'expo-router'
import type { ReactNode } from 'react'
import { ScrollView, View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { Image } from '@/src/elements/image'
import { Typography } from '@/src/elements/text/Typography'
import { useRoutes } from '@/src/general/utils/routes'
import { useTranslate } from '@/src/lang/useTranslate'

export const EmptyMessagesScreen = (): ReactNode => {
  const { t } = useTranslate()
  const { routes } = useRoutes()
  const { navigate } = useRouter()

  return (
    <ScrollView className="pb-10">
      <View className="mx-auto max-w-screen-sm flex-col gap-4 px-7 pt-8">
        <View className="mx-auto h-80 w-64">
          <Image source={require('@/img/messages/empty-messages-list.png')} contentFit="contain" />
        </View>
        <Typography center bold>
          {t('message.list.title.conversation')}
        </Typography>
        <Typography center>{t('message.list.title.intention')}</Typography>
        <Button variant="solid" colors="primary" onPress={() => navigate(routes.intentions())}>
          {t('message.list.title.cta')}
        </Button>
      </View>
    </ScrollView>
  )
}
